export default [
  {
    name: "debian",
    href: "https://www.debian.org/",
  },
  {
    name: "ubuntu",
    href: "https://ubuntu.com/",
  },
  {
    name: "linux",
    href: "https://ru.wikipedia.org/wiki/Linux",
  },
  {
    name: "blender",
    href: "https://www.blender.org/",
  },
  {
    name: "autocad",
    href: "https://www.autodesk.ru/products/autocad/overview",
  },
  {
    name: "houdini",
    href: "https://www.sidefx.com/",
  },
  {
    name: "3dsmax",
    href: "https://www.autodesk.ru/products/3ds-max/overview",
  },
  {
    name: "windows",
    href: "https://www.microsoft.com/ru-ru/windows-server",
  },
  {
    name: "maya",
    href: "https://www.autodesk.com/products/maya/overview",
  },
];
